import {
  MALTA_OFFERED_COURSES,
  MALTA_OFFERED_COURSES_BY_LABEL,
} from "@/src/constants/AdmissionOffice/Malta/maltaOfferedCoursesConfig";
import { normalizeAdmissionSemesterValue } from "@/src/constants/AdmissionOffice/admissionSemesterOptions";

export const resolveMaltaOfferedCourseLabel = ({
  category,
  admissionSemester,
  selectedCourse,
}: {
  category?: string;
  admissionSemester?: string;
  selectedCourse?: string;
}): string => {
  const trimmedSelectedCourse = selectedCourse?.trim() ?? "";
  if (trimmedSelectedCourse && MALTA_OFFERED_COURSES_BY_LABEL[trimmedSelectedCourse]) {
    return trimmedSelectedCourse;
  }

  const trimmedCategory = category?.trim() ?? "";
  const trimmedSemester = normalizeAdmissionSemesterValue(admissionSemester);
  if (!trimmedCategory) return "";

  const exactMatch = MALTA_OFFERED_COURSES.find(
    (entry) =>
      entry.category === trimmedCategory &&
      normalizeAdmissionSemesterValue(entry.admissionSemester) === trimmedSemester,
  );
  if (exactMatch) return exactMatch.label;

  const categoryMatch = MALTA_OFFERED_COURSES.find((entry) => entry.category === trimmedCategory);
  return categoryMatch?.label ?? "";
};
